export default class DepartModel {

    id = 0;
    code = '';
    name = '';
    createUid = '';
    updateUid = '';
    createTime = '';
    updateTime = '';

    createUserName = '';
    updateUserName = '';

}